
import * as OM from '@/Model';
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { LocalizationServices } from '@/services/LocalizationServices';

@Options({})
export default class domandeSection extends Vue {

    @Prop() comments: OM.AppUserCommentListVM[]
    @Prop() addQuestionCallback: (questionText: string, publicQuestion: OM.CommentVisibility) => void;

    model = OM
    questionText: string = "";
    publicQuestion: OM.CommentVisibility = OM.CommentVisibility.Public;

    placeholder1: string = "";

    created(){
        this.placeholder1 =  LocalizationServices.GetLocalizedValue('Scrivi qui la tua domanda [...]','Scrivi qui la tua domanda [...]');
    }

    get domandeUtente(){
        const loggedUserIdentifier = this.$store.state.user.identifier
        return this.comments.filter(x => !x.repliedToComment && x.createdBy.identifier == loggedUserIdentifier)
    }

    get domandeAltri(){
        const loggedUserIdentifier = this.$store.state.user.identifier
        return this.comments.filter(x => !x.repliedToComment && x.createdBy.identifier != loggedUserIdentifier)
    }

    findAnswer(commentIdentifier: string){
        return this.comments.find(x => x.repliedToComment && x.repliedToComment == commentIdentifier)
    }

    updatePublicQuestion(value: boolean){
        if(value)
            this.publicQuestion = OM.CommentVisibility.Public
        else
            this.publicQuestion = OM.CommentVisibility.Private
    }

    submitQuestion(){
        this.addQuestionCallback(this.questionText, this.publicQuestion)
        this.questionText = ""
    }
}
